import "../assets/css/App.css";
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { Flex } from "@chakra-ui/react";
import NoAccountsIcon from "@mui/icons-material/NoAccounts";
import PanToolIcon from "@mui/icons-material/PanTool";

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title='Lilofy | Acceso Denegado';
  }, [])


  return (
    <Box
      minHeight={"85vh"}
      display="flex"
      alignItems={"center"}
      justifyContent="center"
    >
      <Flex direction={"column"} alignItems={"center"} gap="4">
        <Typography variant="unauth">¡Oh no!</Typography>
        <Typography variant="unauth">Acceso Restringido</Typography>

        {/* <Typography variant='h4' className='mt-3' sx={{color: '#cc0000'}}>Error 401</Typography> */}
        <Flex direction={"row"} alignItems={"center"} gap="2">
          <PanToolIcon sx={{ fontSize: "80px", color: "#cc0000" }} />
          <NoAccountsIcon sx={{ fontSize: "80px", color: "#cc0000" }} />
        </Flex>

        <Box sx={{ marginTop: "40px" }}>
          {/* <Button variant="contained" onClick={() => navigate(-2)}>
            Regresar a la Página Anterior
          </Button> */}
        </Box>
      </Flex>
    </Box>
  );
};

export default UnauthorizedPage;
